import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Image,
  Text,
  FormControl,
  Input,
  Button,
  InputGroup,
  Stack,
  Link,
  InputRightElement,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useForm } from "react-hook-form";
import logoLogin from "../../assets/images/logo-main.png";
import background from "../../assets/images/background-login.png";
import toast from "react-hot-toast";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { employeeCall } from "../../api/employee";
import { useNavigate } from "react-router-dom";
import { checkTokenExpiration } from "../../utils/utils";

const schema = Yup.object().shape({
  password: Yup.string()
    .required("Mật khẩu là bắt buộc")
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%&*])[a-zA-Z0-9!@#$%&*]+$/,
      "Mật khẩu phải có ít nhất 1 chữ hoa, 1 chữ thường, 1 số, 1 ký tự đặc biệt, và không chứa dấu."
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Mật khẩu không khớp")
    .required("Nhập lại mật khẩu là bắt buộc"),
});

const ChangePassword = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  });

  const [accessToken, setAccessToken] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const getCookie = (name) => {
      return document.cookie
        .split("; ")
        .find((row) => row.startsWith(name + "="))
        ?.split("=")[1];
    };

    const accessTokens = getCookie("accessTokenForgot");

    setAccessToken(accessTokens);
    const checkToken = () => {
      if (!accessTokens) {
        navigate("/forgot");
      }

      if (!checkTokenExpiration(accessTokens)) {
        setIsModalOpen(true);
      }
    };

    const interval = setInterval(checkToken, 10 * 1000);

    return () => clearInterval(interval);
  }, [navigate]);

  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);

  const passwordValue = watch("password");
  const confirmPasswordValue = watch("confirmPassword");

  const handleForgot = async (data) => {
    if (!checkTokenExpiration(accessToken)) {
      toast.dismiss("OTP hết hạn");
      navigate("/forgot");
    }

    const toastCreate = toast.loading("Đang thay đổi mật khẩu ...");
    try {
      await employeeCall.resetPassword(data, accessToken);

      toast.success("Xác nhận đổi thành công");
      navigate("/login");
    } catch (error) {
      console.log(error);

      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const handleLogout = () => {
    document.cookie = "accessTokenForgot=; path=/; max-age=0"; // Xoá token
    navigate("/forgot");
  };

  return (
    <Flex
      backgroundImage={`url(${background})`}
      backgroundRepeat={"no-repeat"}
      backgroundColor="var(--color-background)"
      h={"100vh"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Box
        padding={{ base: "40px" }}
        borderRadius={{ base: "16px" }}
        w={{ base: "500px" }}
        minHeight={{ base: "500px" }}
        backgroundColor="var(--color-main)"
        position={"relative"}
      >
        <Flex
          h={"100%"}
          w={"100%"}
          flexDirection={{ base: "column" }}
          alignItems={{ base: "center" }}
        >
          <Image src={logoLogin} />
          <Text
            fontSize={{ base: "26px" }}
            fontWeight={600}
            mt={{ base: "23px" }}
            mb={{ base: "36px" }}
          >
            Đổi mật khẩu
          </Text>
          <Box w={"100%"}>
            <form onSubmit={handleSubmit(handleForgot)}>
              <Flex flexDirection={{ base: "column" }}>
                <FormControl id="password" mb={{ base: "13px" }}>
                  <Text fontSize={{ base: "12px" }} fontWeight={500}>
                    Mật khẩu
                  </Text>
                  <InputGroup>
                    <Input
                      fontSize={{ base: "14px" }}
                      padding={"0px"}
                      borderRadius={"0px"}
                      border={"none"}
                      borderBottom={"1px solid #E1E1E1"}
                      type={showPassword ? "text" : "password"}
                      placeholder="Nhập mật khẩu "
                      _focus={{
                        boxShadow: "none",
                        borderColor: "#E1E1E1",
                      }}
                      {...register("password")}
                    />
                    {passwordValue && (
                      <InputRightElement>
                        <IconButton
                          _hover={{
                            bg: "var(--color-main)",
                          }}
                          backgroundColor={"none"}
                          icon={showPassword ? <ViewIcon /> : <ViewOffIcon />}
                          onClick={() => setShowPassword(!showPassword)}
                          variant="ghost"
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }
                        />
                      </InputRightElement>
                    )}
                  </InputGroup>
                  {errors.password && (
                    <Text fontSize={{ base: "12px" }} color={"red"}>
                      {errors.password.message}
                    </Text>
                  )}
                </FormControl>
                <FormControl id="password" mb={{ base: "13px" }}>
                  <Text fontSize={{ base: "12px" }} fontWeight={500}>
                    Nhập lại mật khẩu
                  </Text>
                  <InputGroup>
                    <Input
                      fontSize={{ base: "14px" }}
                      padding={"0px"}
                      borderRadius={"0px"}
                      border={"none"}
                      borderBottom={"1px solid #E1E1E1"}
                      type={showRePassword ? "text" : "password"}
                      placeholder="Nhập lại mật khẩu "
                      _focus={{
                        boxShadow: "none",
                        borderColor: "#E1E1E1",
                      }}
                      {...register("confirmPassword")}
                    />
                    {confirmPasswordValue && (
                      <InputRightElement>
                        <IconButton
                          _hover={{
                            bg: "var(--color-main)",
                          }}
                          backgroundColor={"none"}
                          icon={showRePassword ? <ViewIcon /> : <ViewOffIcon />}
                          onClick={() => setShowRePassword(!showRePassword)}
                          variant="ghost"
                          aria-label={
                            showRePassword ? "Hide password" : "Show password"
                          }
                        />
                      </InputRightElement>
                    )}
                  </InputGroup>
                  {errors.confirmPassword && (
                    <Text fontSize={{ base: "12px" }} color={"red"}>
                      {errors.confirmPassword.message}
                    </Text>
                  )}
                </FormControl>
                <Stack
                  fontSize={{ base: "12px" }}
                  direction="row"
                  justifyContent="flex-end"
                  align="center"
                  pb={{ base: "58px" }}
                >
                  <Link
                    href="/singin"
                    color="var(--color-option-employee-hover)"
                    fontSize={"13px"}
                    fontWeight={600}
                    lineHeight={"normal"}
                  >
                    Đăng nhập
                  </Link>
                </Stack>
                <Button
                  backgroundImage="var(--color-button)"
                  _hover={{
                    backgroundImage: "var(--color-button)",
                  }}
                  type="submit"
                >
                  <Text
                    color={"#FFF"}
                    fontSize={{ base: "15px" }}
                    fontWeight={700}
                  >
                    Đổi mật khẩu
                  </Text>
                </Button>
              </Flex>
            </form>
          </Box>
        </Flex>
      </Box>
      <Modal isOpen={isModalOpen} isCentered>
        <ModalOverlay />
        <ModalContent maxW="625px">
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            p={"25px 24px 24px 24px"}
            borderBottom={"1px solid var(--color-boder)"}
          >
            <Text
              fontSize={"18px"}
              fontWeight={600}
              lineHeight={"normal"}
              color="var(--color-black)"
            >
              OTP hết hạn
            </Text>
          </Flex>
          <Flex p="24px" justifyContent="space-between">
            <Text>
              ⚠️ Mã OTP Đã Hết Hạn. Bạn sẽ được chuyển hướng đến trang lấy mã
              OTP.
            </Text>
          </Flex>
          <Box p="24px" display={"flex"} justifyContent={"end"}>
            <Button
              display={"flex"}
              alignItems={"center"}
              p={"10px 16px 10px 12px"}
              gap={"8px"}
              backgroundImage="var(--color-button)"
              _hover={{
                backgroundImage: "var(--color-button)",
              }}
              color={"var(--color-main)"}
              onClick={handleLogout}
            >
              OK
            </Button>
          </Box>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default ChangePassword;
